import { render, staticRenderFns } from "./MoneyClaimsView.vue?vue&type=template&id=6cbff2d1&"
import script from "./MoneyClaimsView.vue?vue&type=script&lang=js&"
export * from "./MoneyClaimsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports